import React from 'react';

export default function UnknownPage() {
  return (
    <h1>Route not yet implemented</h1>
  );
}
